module.exports = __webpack_public_path__ + "8a76fe021a4040b370538d3139b24970.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-16.png
// module id = 2593
// module chunks = 0